import React from 'react';
import clone from 'clone';
import classNames from 'classnames';
import './category/showCategoryTemplateThree';
import './category/showCategoryTemplateTwo';
import './category/showCategoryTemplate';


class CategoryBlock extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'CategoryBlock';
    this.showAllTerms = this.showAllTerms.bind(this);
    this.state = {
      'selectedTemplate': '',
    };
  }
  componentWillMount() {
    this.loadSettings(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.loadSettings(nextProps);
  }
  loadSettings(props) {
    const block = props.block.categorySettings !== undefined ? props.block.categorySettings.categoryTemplate : {};
    if (block.length) {
      block.map((item) => {
        if (item.isChecked === 'true' || item.isChecked === true) {
          const selectedTemplate = item.value;
          this.setState({ selectedTemplate });
        }
      });
    }
  }
  showAllTerms(taxonomy, index) {
    let columnSize;
    columnSize = classNames({
      'flex-lg-12': this.props.block.categorySettings.desktop_hd === '1',
      'flex-lg-6': this.props.block.categorySettings.desktop_hd === '2',
      'flex-lg-4': this.props.block.categorySettings.desktop_hd === '3',
      'flex-lg-3': this.props.block.categorySettings.desktop_hd === '4',
      'flex-md-12': this.props.block.categorySettings.desktop === '1',
      'flex-md-6': this.props.block.categorySettings.desktop === '2',
      'flex-md-4': this.props.block.categorySettings.desktop === '3',
      'flex-md-3': this.props.block.categorySettings.desktop === '4',
      'flex-sm-6': this.props.block.categorySettings.tablet === '2',
      'flex-sm-12': this.props.block.categorySettings.tablet === '1',
      'flex-sm-4': this.props.block.categorySettings.tablet === '3',
      'flex-xs-6': this.props.block.categorySettings.mobile === '2',
      'flex-xs-12': this.props.block.categorySettings.mobile === '1',
    });
    this.ComponentName = ReactiveTemplateCategories[this.state.selectedTemplate];
    return (<div className={columnSize} key={'templateCategory-' + index} ><this.ComponentName taxonomy={taxonomy} /></div>);
  }
  render() {
    const categorySettings = this.props.block.categorySettings ? this.props.block.categorySettings : {};
    const { settingsData } = this.props;
    const allTermsCategory = [];
    const numberOfCategories = categorySettings.numberOfCategories ? categorySettings.numberOfCategories : null;
    const loadMoreOption = categorySettings.loadMoreOption ? categorySettings.loadMoreOption : null;
    const viewMoreLink = categorySettings.viewMoreLink ? categorySettings.viewMoreLink : null;
    const categoryLoadMoreOption = {
      viewMoreLink,
    };
    const ThemeComponent = window.ReactiveTheme[settingsData.theme] !== undefined ? window.ReactiveTheme[settingsData.theme].bar : {};
    let term = '';
    if (categorySettings.hasOwnProperty('termName')) {
      term = categorySettings.termName.value;
    }
    const { terms } = this.props.helperData;
    let allTerms = [];
    if (terms.hasOwnProperty(term)) {
      allTerms = terms[term].linear;
    }
    for (let i = 0; i < numberOfCategories; i++) {
      if (allTerms[i] !== undefined) {
        allTermsCategory[i] = allTerms[i];
      } else {
        break;
      }
    }
    const ifOpen = this.props.isToggle ? 'active' + ' ' + 'rq-category-container' : '';
    return (<div className={ ifOpen }>
        {this.props.isToggle ? <div>
        <div className="flex-row">
          {allTermsCategory.map(this.showAllTerms)}
        </div>
          { loadMoreOption === 'true' ? <div className="rq-loadmore-button"><ThemeComponent.categoryLoadMore {...categoryLoadMoreOption} /></div> : null
        } </div> : null}
      </div>
    );
  }
}

CategoryBlock.propTypes = {
  'allLayout': React.PropTypes.array,
  'settingsData': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'isToggle': React.PropTypes.bool,
};

export default CategoryBlock;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/categoryBlock.js
 **/